export default __webpack_public_path__ + "static/media/bcn_logo.7728e28b.png";